var path = '/_common/directives/ifastGrid/columnDirectives/htmlInputText.tpl.html';
var html = "<span> <label class=label-hidden for=k-textbox{{$id}}>CheckBox</label> <input class=k-textbox id=k-textbox{{$id}} type=text ng-model=value ng-disabled=!enabled ifast-number-restriction/> </span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/_common/directives/ifastGrid/columnDirectives/htmlInputText.tpl.html
// module id = 777
// module chunks = 0 2